import { NumberField as BaseNumberField, NumberInputProps } from '@wyz/ui';
import * as React from 'react';
import { useI18n } from '~/common/context';

const NumberField: React.FC<
  NumberInputProps & { feedbackType?: 'tooltip' | 'inline' }
> = (props) => {
  const { t } = useI18n();

  return <BaseNumberField {...props} translate={t} />;
};

export default NumberField;
